module.exports = "/assets/about/success/dream_employer.png?8mhRNIQ";